// import React from "react";
import BlackberryHeroCaraousel from "../bbComponents/BlackberryHeroCaraousel";
// import BlackberryTrendingProducts from "../bbComponents/BlackberryTrendingProducts";
// import BlackberryHomeCategory from "../bbComponents/BlackberryHomeCategory";
// import BlackberryHero from "../bbComponents/BlackberryHero";
import BlackberryProducts from "../bbComponents/BlackberryProducts";
import BlackberryGallery from "../bbComponents/BlackberryGallery";
// import BlackberryCollection from "../bbComponents/BlackberryCollection";
// import BlackberryFooter from "../bbComponents/BlackberryFooter";
// import BlackberryBlogs from "../bbComponents/BlackberryBlogs";
import BlackberryService from "../bbComponents/BlackberryService";
import BlackberryShowcase from "../bbComponents/BlackberryShowcase";
import BlackberryWebfeatures from "../bbComponents/BlackberryWebfeatures";
// import BlackberryCategory from "../bbComponents/BlackberryCategory";
// import BlackberryVideo from "../bbComponents/BlackberryVideo";
import BlackberryProductweek from "../bbComponents/BlackberryProductweek";
import BlackberryNavCategory from "../bbComponents/BlackberryNavCategory";
import BlackberryReviews from "../bbComponents/BlackberryReviews";
import BlackberryMap from "../bbComponents/BlackberryMap";
import BlackberrySpecialDesignCategory from "../bbComponents/BlackberrySpecialDesignCategory";
import BlackberryProductSlider from "../bbComponents/BlackberryProductSlider";

const BlackberryHome = () => {
  return (
    <div>
      <BlackberryNavCategory />
      <BlackberryHeroCaraousel />
      <BlackberryProductSlider />
      {/* <BlackberryHomeCategory /> */}
      <BlackberrySpecialDesignCategory />
      {/* <BlackberryTrendingProducts /> */}
      {/* <BlackberryHero /> */}
      <BlackberryProducts />
      <BlackberryGallery />
      {/* <BlackberryCollection /> */}
      {/* <BlackberryCategory /> */}
      {/* <BlackberryVideo /> */}
      <BlackberryProductweek />
      {/* <BlackberryBlogs /> */}
      <BlackberryService />
      <BlackberryMap />
      <BlackberryShowcase />
      <BlackberryReviews />
      <BlackberryWebfeatures />
      {/* <BlackberryFooter /> */}
    </div>
  );
};

export default BlackberryHome;
